import baseApplicationItem from './baseApplicationItem'
import {merge} from 'lodash'

const module = {
  endpoint: 'vat',
  getNew: {
    id: null,
    deleted: false,
    name: null,
    symbol: null
  },
  tableInfo: {
    tableFields: [
      {
        name: '__component:badge-deleted-column',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__checkbox',
        title: '',
        class: 'primary'
      },
      {
        name: 'id',
        title: 'id',
        sortField: 'id'
      },
      {
        name: 'name',
        title: 'nome',
        sortField: 'name'
      },
      {
        name: 'value',
        title: 'Valore',
        sortField: 'value'
      },
      {
        name: '__component:actions-column',
        title: '',
        dataClass: 'text-center'
      }
    ],
    sortFunctions: {
    }
  }
}

export default merge(module, baseApplicationItem)



// WEBPACK FOOTER //
// ./src/application/vats.js